import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const self = this;
        const element = self.element;
        self.multiple = element.dataset.multiple;
        self.default = element.dataset.default;
        self.selectElm = element.querySelector('select');

        self.wrapSelect();

        const optionData = [];
        self.selectElm.querySelectorAll("option").forEach(function (option) {
            const id = option.hasAttribute("data-id") ? option.getAttribute("data-id") : '0';
            if (option.hasAttribute("data-parent")) {
                const parent = option.hasAttribute("data-parent") ? option.getAttribute("data-parent") : '0';
                if (parent === '0') {
                    const children = [];
                    self.selectElm.querySelectorAll("option").forEach(function (option2) {
                        const parent2 = option2.hasAttribute("data-parent") ? option2.getAttribute("data-parent") : '0';
                        if (id === parent2) {
                            children.push({
                                value: option2.getAttribute("value"),
                                selected: option2.hasAttribute("selected"),
                                name: option2.innerText,
                            });
                        }
                    });
                    optionData.push({
                        value: option.getAttribute("value"),
                        selected: option.hasAttribute("selected"),
                        children: children,
                        name: option.innerText,
                    });
                }
            } else {
                optionData.push({
                    value: option.getAttribute("value"),
                    selected: option.hasAttribute("selected"),
                    children: [],
                    name: option.innerText,
                });
            }
        });

        let html = '';
        optionData.forEach(function (options) {
            if (self.multiple) {
                html += `<li data-value="${options.value}" data-name="${options.name}">
                         <label>
                         <span class="checkbox-container">
                         <input type="checkbox" ${options.selected ? 'checked' : ''}/>
                         <span class="checkmark"></span>
                         <span class="name">${options.name}</span>
                         </span>
                         </label>
                         </li>`;
            } else {
                if (options.children.length > 0) {
                    html += `<li data-value="${options.value}" data-name="${options.name}"><span class="name">${options.name}</span>`;
                    html += `<ul class="sub-menu">`;
                    options.children.forEach(function (suboptions) {
                        html += `<li data-value="${suboptions.value}" data-name="${suboptions.name}"><span class="name">${suboptions.name}</span></li>`;
                    });
                    html += `</ul>`;
                    html += `</li>`;
                } else {
                    html += `<li data-value="${options.value}" data-name="${options.name}"><span class="name">${options.name}</span></li>`;
                }
            }
        });

        const ul = element.querySelector("ul.select-dropdown");
        ul.insertAdjacentHTML("afterbegin", html);

        self.updateSelect();
        self.buildDropdown();

        document.addEventListener("click", (e) => {
            if (!element.querySelector(".js-select").contains(e.target)) {
                ul.style.display = "none";
            }
        });
    }

    updateSelect() {
        const self = this;
        self.selected = self.element.querySelector(".selected");

        const selectedText = [];
        for (let i = 0; i < self.selectElm.options.length; i++) {
            if (self.selectElm.options[i].selected) {
                selectedText.push(self.selectElm.options[i].text);
            }
        }

        self.selected.innerHTML = selectedText.length ? selectedText.join(', ') : self.default;
        self.selected = self.element.querySelector(".selected");

        const ul = self.element.querySelector("ul.select-dropdown");
        self.selected.addEventListener("click", function () {
            ul.style.display = "block";
        });

        self.selected.querySelectorAll("span").forEach(function (span) {
            span.addEventListener("click", function () {
                const value = span.getAttribute("data-value");
                self.element.querySelector(`input[name="${value}"]`).checked = false;
                self.buildDropdown();
                self.updateData();
            });
        });
    }

    updateData() {
        const self = this;
        const selected = self.selected;
        let selectedNames = [];
        const selectedValues = [];

        self.element.querySelectorAll("ul.select-dropdown li").forEach((li) => {
            if (li.querySelector("input[type='checkbox']").checked) {
                const value = li.getAttribute("data-value");
                const name = li.getAttribute("data-name");
                selectedNames.push(name);
                selectedValues.push(value);
            }
        });

        for (let i = 0; i < self.selectElm.options.length; i++) {
            self.selectElm.options[i].selected = selectedValues.indexOf(self.selectElm.options[i].value) >= 0;
        }

        selectedNames = selectedNames.join(", ");
        if (!selectedNames) {
            selectedNames = self.default;
        }
        selected.innerHTML = selectedNames;
    }

    buildDropdown() {
        const self = this;
        const selected = self.selected;
        const multiple = self.multiple;

        self.element.querySelectorAll("ul.select-dropdown li span.name, ul.select-dropdown li").forEach((span) => {
            span.addEventListener("click", () => {
                if (multiple) {
                    self.updateData();
                } else {
                    let val = '';
                    let name = '';
                    if (span.nodeName === "SPAN") {
                        const parent = span.parentElement;
                        val = parent.getAttribute("data-value");
                        name = parent.getAttribute("data-name");
                    } else {
                        val = span.getAttribute("data-value");
                        name = span.getAttribute("data-name");
                    }
                    self.selectElm.value = val;
                    self.selectElm.dispatchEvent(new Event('change'));
                    selected.innerHTML = name;
                    const ul = self.element.querySelector("ul.select-dropdown");
                    ul.style.display = "none";
                }

                const form = self.element.querySelector('form');
                if (form) {
                    form.submit();
                }
            });
        });
    }

    wrapSelect() {
        const self = this;
        const wrapper = document.createElement('div');
        wrapper.classList = 'js-select';
        self.selectElm.parentNode.insertBefore(wrapper, self.selectElm);
        wrapper.appendChild(self.selectElm);
        self.selectElm.insertAdjacentHTML("afterend", '<ul class="select-dropdown"></ul>');
        self.selectElm.insertAdjacentHTML("beforebegin", '<div class="selected"></div>');
    }
}
